import { useContext } from 'react';
import ABTestContext, { isFeatureFlagActive, FEATURE_FLAG_KEYS } from "../ABTestContext";

export const useFeatureFlags = (cookies) => {
  const abTestContext = useContext(ABTestContext);
  const featureFlagBDPNewDesign = isFeatureFlagActive(
    FEATURE_FLAG_KEYS.BOATS_BDP_REFRESH,
    abTestContext?.featureFlags,
    cookies
  );
  const featureFlagFuzzySponsored = isFeatureFlagActive(
    FEATURE_FLAG_KEYS.FUZZY_SPONSORED_BOATS,
    abTestContext?.featureFlags,
    cookies
  );
  const featureFlagRandomizedSponsored = isFeatureFlagActive(
    FEATURE_FLAG_KEYS.RANDOMIZED_SPONSORED,
    abTestContext?.featureFlags,
    cookies
  );
  const featureFlagHideContactModalForm = isFeatureFlagActive(
    FEATURE_FLAG_KEYS.BDP_HIDE_CONTACT_MODAL_FORM,
    abTestContext?.featureFlags,
    cookies
  );

  const featureFlagListingImageCarousel = isFeatureFlagActive(
    FEATURE_FLAG_KEYS.LISTING_IMAGE_CAROUSEL,
    abTestContext?.featureFlags,
    cookies
  );
  return { featureFlagBDPNewDesign, featureFlagFuzzySponsored, featureFlagRandomizedSponsored, featureFlagHideContactModalForm, featureFlagListingImageCarousel };
};
